/** @module builtins/Array */

/* eslint-disable no-extend-native */

if (!Array.prototype.unique) {
    /**
     * The callback function provided to unique method of the Array class.
     * @callback Array~uniqueCallback
     * @param {*} element - The element being processed in the array.
     * @param {Number} index - The index of the current element being processed in the array.
     * @param {Array.<*>} array - The array unique was called upon.
     * @returns {*} The value to map the element to when comparing.
     */
    /**
     * Return a copy of the array with duplicates removed.
     * @param {Array~uniqueCallback} [mapping] - Return the value of the element to use in comparison.
     * @returns {*} A copy of the array with duplicates removed.
     */
    Object.defineProperty(Array.prototype, 'unique', {
        value: function (mapping) {
            mapping ??= x => x;
            const seen = new Set();
            return this.filter(element => {
                const mapped = mapping(element);
                const has = seen.has(mapped);
                if (!has) {
                    seen.add(mapped);
                }
                return !has;
            });
        },
    });
}

if (!Array.prototype.equals) {
    /**
     * The callback function provided to equals method of the Array class.
     * @callback Array~equalsCallback
     * @param {*} element1 - The first element to compare.
     * @param {*} element2 - The second element to compare.
     * @returns {Boolean} Return true if elements are equal or false otherwise.
     */
    /**
     * Compare the array elementwise with the other array to see if they are equal. This is a shallow comparison.
     * @param {Array.<*>} other - The other array.
     * @param {Array~equalsCallback} [compareFunction] - Return whether or not the elements are equal.
     * @returns {Boolean} Whether or not the arrays contain exactly the same elements.
     */
    Object.defineProperty(Array.prototype, 'equals', {
        value: function (other, compareFunction) {
            compareFunction ??= (a, b) => a === b;
            return this.length === other.length && this.every((e, i) => compareFunction(e, other[i]));
        },
    });
}

{
    /**
     * The callback function provided to filter method of the Array class.
     * @callback Array~filterCallback
     * @param {*} element - The element being processed in the array.
     * @param {Number} index - The index of the current element being processed in the array.
     * @param {Array.<*>} array - The array filter was called upon.
     */
    const oldfilter = Array.prototype.filter;
    /**
     * Overrides the builtin filter method to provide one that requires no arguments.
     * @param {Array~filterCallback} callback - Function to test each element in the array.
     *     If unspecified will default to identity.
     * @param {Object} [thisArg] - Optional. Object to use as this when executing callback.
     */
    Object.defineProperty(Array.prototype, 'filter', {
        value: function (callback, thisArg) {
            return oldfilter.call(this, callback || (x => x), thisArg);
        },
    });
}

if (!Array.prototype.rotate) {
    /**
     * Rotate the array elements.
     * @param {Number} N - The amount of elements to rotate by. If negative, rotates in reverse.
     * @returns {*} A rotated copy of the array.
     */
    Object.defineProperty(Array.prototype, 'rotate', {
        value: function (N) {
            return [...this.slice(N), ...this.slice(0, N)];
        },
    });
}

/* eslint-enable no-extend-native */
